// extracted by mini-css-extract-plugin
module.exports = {"input":"FakeAutocompleteField_input__2BA7e","fakeInput":"FakeAutocompleteField_fakeInput__Qd13u"};